


























import { Component, Vue, Prop } from "vue-property-decorator";
import { Property } from "@/models/Property";
import Filters from "@/common/Filters";

@Component({
  filters: {
    diffToString: Filters.diffToString,
  },
})
export default class PropertyList extends Vue {
  @Prop({ default: () => [] })
  private properties!: Property[];

  @Prop({ default: () => undefined })
  private data: object | undefined;

  private convertToTime(time: number) {
    return Filters.diffToString(time);
  }
}
